import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

interface ServiceCardProps {
  number: string;
  title: string;
  description: string;
  features: string[];
  timeline: string;
  investment: string;
}

const ServiceCard = ({
  number,
  title,
  description,
  features,
  timeline,
  investment,
}: ServiceCardProps) => {
  return (
    <div className="group relative bg-card border border-border p-8 lg:p-12 transition-all duration-medium hover:-translate-y-1">
      <div className="flex items-start justify-between mb-6">
        <span className="text-6xl lg:text-7xl font-headline font-bold text-muted opacity-20">
          {number}
        </span>
      </div>

      <h3 className="text-2xl lg:text-3xl font-headline font-bold text-primary mb-4 tracking-tight">
        {title}
      </h3>

      <p className="text-base lg:text-lg font-body text-text-secondary mb-8 leading-relaxed">
        {description}
      </p>

      <div className="space-y-3 mb-8">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start gap-3">
            <Icon
              name="CheckIcon"
              size={20}
              className="text-primary mt-0.5 flex-shrink-0"
            />
            <span className="text-sm lg:text-base font-body text-text-primary">
              {feature}
            </span>
          </div>
        ))}
      </div>

      <div className="pt-6 border-t border-border">
        <div>
          <p className="text-xs font-cta font-semibold tracking-wide uppercase text-muted-foreground mb-1">
            Starting From
          </p>
          <Link 
            href="/contact"
            className="text-lg font-headline font-bold text-primary hover:underline"
          >
            Contact for pricing
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;